var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 150,
    viewBox: "0 0 1440 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_228)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 150,
    fill: "url(#paint0_linear_15_228)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.67 -103.778C1337.01 -26.5439 1351.49 119.691 1547.96 137.214",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.14 -55.7776C1372.47 21.4561 1386.95 167.691 1583.43 185.214",
    stroke: "#A8A8A8",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_228",
    x1: 720,
    y1: 0,
    x2: 720,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#332BD2",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2A8B",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 150,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondBanner);
export default __webpack_public_path__ + "static/media/second_banner.4fdc6bbb6c5f0198712aab751d39da83.svg";
export { ForwardRef as ReactComponent };